module.exports = __webpack_public_path__ + "img/progress_059.637c806d.png";